export const imgBaseUrl = ''

export function constructQueryParams(params) {
  let url = constructUrl(params)
  return url.slice(0, url.length - 1)
}
function constructUrl(params = '') {
  if (typeof(params) !== 'object') {
    return ''
  }
  let url = '?'
  for (let key in params) {
    let value = params[key]
    if (typeof(value) === 'object') {
      url += constructUrl(value).replace('?', '')
    } else if (value || value === 0) {
      url = `${url}${key}=${value}&`
    }
  }
  return url
}

export function isPDF(imgURL) {
  return /(pdf)$/i.test(imgURL && imgURL.toLowerCase())
}

/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

/**
 * validate mobile
 * @param mobile
 * @returns {boolean}
 */
export function validateMobile(mobile) {
  const re = /^(13[0-9]|14[57]|15[0-9]|16[0-9]|17[0135678]|18[0-9]||19[0-9]|)[0-9]{8}$/
  return re.test(mobile)
}

/**
 * validate CardId
 * @param CardId
 * @returns {boolean}
 */
export function validateCardId(CardId) {
  const re = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/ //验证身份证
  return re.test(CardId)
}

export function validatePersonalBankCardId(BankCardId) {
  const re = /^([1-9]{1})(\d{14}|\d{15}|\d{18})$/ //验证对私账户
  return re.test(BankCardId)
}

export function validateBusinessBankCardId(BankCardId) {
  const re = /^([1-9]{1})(\d{14}|\d{15}|\d{18}|\d{19})$/ //验证对公账户
  return re.test(BankCardId)
}


export function handleArea(areaObject) {
  let arr = [];
  for (let [k, v] of Object.entries(areaObject['100000'])) {
    let object = {value: v, label: v, key: k, children: []}
    for (let [k, v] of Object.entries(areaObject[object.key])) {
      let object1 = {value: v, label: v, key: k}
      object.children.push(object1)
    }
    arr.push(object)
  }
  return arr
}

export function checkPhone(rule, value, callback) {
  if (!value) {
    callback(new Error('Please enter your mobile number'))
  } else {
    callback()
    // if (!validateMobile(value)) {
    //   callback(new Error('Please check whether the mobile number is correct'))
    // } else {
    //   callback()
    // }
  }
}
export function checkEmail (rule, value, callback) {
   if (value === '') {
     callback(new Error('Please fill in the email address'))
   } else if (!validateEmail(value)) {
     callback(new Error('Please check whether the email is correct'))
   } else {
     callback()
   }
 }
export function checkPassword (rule, value, callback) {
  // 数字、大小写字母、 6-18字符
  let passwordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/ // 验证密码
  if (!value) {
    // callback(new Error('请输入8-16位数字、字母的组合'))
    callback(new Error('Please enter a combination of 8-16 numbers and letters'))
  } else {
    if (!passwordReg.test(value)) {
      // callback(new Error('请输入8-16位数字、字母的组合'))
      callback(new Error('Please enter a combination of 8-16 numbers and letters'))
    } else {
      callback()
    }
  }
}
export function throttle(func, delay) {
  var timer = null
  return function() {
      var context = this
      var args = arguments
      if (!timer) {
          timer = setTimeout(function() {
              func.apply(context, args)
              timer = null
          }, delay)
      }
  }
}
export function compare(property){
  return function(a,b){
    let value1 = a[property]
    let value2 = b[property]
    return value2 - value1
  }
}

